import mitt from "mitt";
import { onMounted, onUnmounted } from "vue";
let emitter;
export function useEventBus() {
  if (!emitter && typeof mitt !== "undefined") {
    emitter = mitt();
  }
  function emit(evt, data) {
    if (!emitter || process.server)
      return;
    return emitter.emit(evt, data);
  }
  function on(evt, cb) {
    if (!emitter || process.server)
      return;
    return emitter.on(evt, cb);
  }
  function off(evt, cb) {
    if (!emitter || process.server)
      return;
    return emitter.off(evt, cb);
  }
  return {
    emit,
    on,
    off
  };
}
export function useEvent(evt, callback) {
  const { on, off } = useEventBus();
  onMounted(() => {
    on(evt, callback);
  });
  onUnmounted(() => {
    off(evt, callback);
  });
}
